import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import Angle from "../../../../../src/entities/Angle/Angle";
import { AnglePoints, Coord } from "../../../../../src/types/Interface";
import calcAngle from "../../../../../src/utils/math/calcAngle";
import calcAngles from "../../../../../src/utils/math/calcAngles";
import getDistanceBtwPoints from "../../../../../src/utils/getDistanceBtwPoints";
import { PINK_ANGLE_COLORS } from "../types/Config";


export default class AngleManager {
  Angles = [new Angle("a1", { color: PINK_ANGLE_COLORS[0], textColor: PINK_ANGLE_COLORS[1] })];
  
  constructor() {
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
  }
  setAllVisible = (v: boolean) => this.Angles.forEach(angle => angle.setVisible(v));
  getAngles = () => this.Angles;
  draw(points: Coord[], clockwise: boolean) {
    this.Angles.forEach((_, aI) => {
      const P = { prev: points[2], curr: points[1], next: points[0] };
      const degree = calcAngle(points[0], points[1], points[2]);
      this.drawAngle(this.Angles[aI], P, degree, clockwise);

    })
  }

  drawAngle(angle: Angle, p: AnglePoints, degree: number, clockwise: boolean) {
    const { startRadian, endRadian } = calcAngles(p.curr, p.prev, p.next);
    const smllDistance = Math.min(getDistanceBtwPoints(p.curr, p.prev), getDistanceBtwPoints(p.curr, p.next));
    angle.smallDistance = Math.floor(smllDistance);
    angle.draw(p.curr, startRadian, endRadian, degree, !clockwise);
    angle.x = p.curr.x;
    angle.y = p.curr.y;
    angle.rotation = 0;
  }
}